"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _deepmerge = _interopRequireDefault(require("deepmerge"));
// eslint-disable-next-line camelcase
// eslint-disable-next-line camelcase
var isWebpack = typeof __webpack_require__ === 'function';
var moduleCache = new Map();

/* eslint-disable global-require,import/no-dynamic-require */
var dynamicRequire = function dynamicRequire(name) {
  try {
    var module = isWebpack ?
    // $FlowFixMe: flow can't parse dynamic requires
    require("__appThemes__/" + name + ".js") :
    // $FlowFixMe: flow can't parse dynamic requires
    require(process.cwd() + "/src/themes/" + name + ".js");

    // eslint-disable-next-line no-underscore-dangle
    return module.__esModule ? module.default : module;
  } catch (err) {
    // ignore
  }
  return {};
};
/* eslint-enable global-require,import/no-dynamic-require */

var requireLocalTheme = function requireLocalTheme(name) {
  var cachedTheme = moduleCache.get(name);
  if (cachedTheme != null) {
    return cachedTheme;
  }
  var localTheme = dynamicRequire(name);
  moduleCache.set(name, localTheme);
  return localTheme;
};
var baseTheme = requireLocalTheme('base');
var getLocalTheme = function getLocalTheme(brand) {
  if (brand) {
    return (0, _deepmerge.default)(baseTheme, requireLocalTheme(brand));
  }
  return baseTheme;
};
var _default = exports.default = getLocalTheme;